'use strict';
angular.module('editingCenterCompiledRouterModule', []).config(['$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.editctr.app.waitcompiled', {
            url: '/waitcompiled?siteid&channelid&mediatype',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/toBeCompiled/main_tpl.html',
                    controller: 'editCompileController',
                },
            },
        })
            .state('front.editctr.app.waitcompiled.recycle', {
                url: '/recycle',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/toBeCompiled/recycle/main_draft_tpl.html',
                        controller: 'editCompileRecycleController',
                    },
                },
            }).state('front.editctr.app.waitcompiled.timingsign', {
                url: '/timingsign',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/toBeCompiled/timingSign/timingSign_tpl.html',
                        controller: 'editCompileTimingSignController',
                    },
                },
            }).state('front.editctr.app.waitcompiled.myshare', {
                url: '/myshare',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/iWo/myManuscript/myShare/myShare_tpl.html',
                        controller: 'myShareCtrl',
                    },
                },
            }).state('appatlas', {
                url: '/appatlas?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/atlas/editCenter_atlas.html',
                        controller: 'EditCenterAtlasController',
                    },
                },
            })
            .state('appnews', {
                url: '/appnews?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/news/editCenter_news.html',
                        controller: 'EditingCenterNewsController',
                    },
                },
            })
            .state('appsubject', {
                url: '/appsubject?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/subject/editCenter_subject.html',
                        controller: 'EditingCenterSubjectController',

                    },
                },
            })
            .state('appwebsite', {
                url: '/appwebsite?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/website/editCenter_website.html',
                        controller: 'EditingCenterAddWebsiteController',
                    },
                },
            })
            .state('appactivity', {
                url: '/appactivity?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/activity/app_activity_tpl.html',
                        controller: 'editingCenterAppActivityController',
                    },
                },
            })
            .state('applive', {
                url: '/applive?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/live/app_live_tpl.html',
                        controller: 'editingCenterAppLiveController',
                    },
                },
            })
            .state('apptopic', {
                url: '/apptopic?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/topic/app_topic_tpl.html',
                        controller: 'editingCenterAppTopicController',
                    },
                },
            })
            .state('appvideo', {
                url: '/appvideo?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/video/app_video_tpl.html',
                        controller: 'editingCenterAppVideoController',
                    },
                },
            }).state('appaudio', {
                url: '/appaudio?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/audio/app_audio_tpl.html',
                        controller: 'editingCenterAppAudioController',
                    },
                },
            }).state('operationalActivity', {
                url: '/operationalActivity?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/operationalActivity/operationalActivityTpl.html',
                        controller: 'editingCenterAppOperationalActivityController',
                    },
                },
            }).state('advertisement', {
                url: '/advertisement?appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/app/toBeCompiled/advertisement/advertisement.html',
                        controller: 'editingCenterAppAdvertisementController',
                    },
                },
            });
    }
]);
